import React from "react";
import useStore from "../store/store";
import Button from "./shared/Button";
import { _getGuestString } from "../utils/_getGuestString";
import { handleStepTwo, handleStepThree, handleStepFour } from "../utils/_handleSteps";

const getTitle = (step, currentRoomId) => {
  switch (step) {
    case 1:
      return "Укажите количество гостей";

    case 2:
      return `Выберите номер ${currentRoomId}`;

    case 3:
      return `Выберите программу`;

    case 4:
      return `Выберите желаемую дату заезда*`;

    default:
      break;
  }
};



const LeftHeader = ({ isBtnDisabled = false, setIsBtnDisabled = () => {} }) => {
  const {
    step,
    increaseStep,
    decreaseStep,
    rooms,
    setActiveRoom,
    setArrivalDate,
    activeRoom,
    activeGuest,
    setActiveGuest,
    arrivalDate,
    updatePrice,
    setExpress,
    setExpressCount,
    express,
  } = useStore((state) => state);

  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const backIsVisible = step > 1;

  const nextIsVisible = step < 5;

  const currentRoom = rooms.find((item) => item.id === activeRoom) || rooms[0];

  const handleNextStep = () => {
    scrollToTop();
    switch (step) {
      case 1:
        increaseStep();
        setActiveRoom(rooms[0].id);
        break;

      case 2:
        handleStepTwo(
          rooms,
          setActiveRoom,
          setActiveGuest,
          currentRoom,
          increaseStep,
          decreaseStep,
          setIsBtnDisabled,
          false
        );
        break;

      case 3:
        handleStepTwo(
          rooms,
          setActiveRoom,
          setActiveGuest,
          currentRoom,
          increaseStep,
          decreaseStep,
          setIsBtnDisabled,
          false,
        );
        break;

      case 4:
        handleStepFour(
          rooms,
          arrivalDate,
          setArrivalDate,
          updatePrice,
          setExpress,
          increaseStep,
          decreaseStep,
          false,
          setExpressCount,
        );
        break;

      default:
        break;
    }
  };

  const handlePrevStep = () => {
    scrollToTop();
    switch (step) {
      case 1:
        break;

      case 2:
        handleStepTwo(
          rooms,
          setActiveRoom,
          setActiveGuest,
          currentRoom,
          increaseStep,
          decreaseStep,
          setIsBtnDisabled,
          true
        );
        break;

      case 3:
        handleStepThree(
          rooms,
          setActiveRoom,
          currentRoom,
          activeGuest,
          setActiveGuest,
          increaseStep,
          decreaseStep,
          setIsBtnDisabled,
          true
        );
        break;

      case 4:
        handleStepFour(
          rooms,
          arrivalDate,
          setArrivalDate,
          updatePrice,
          setExpress,
          increaseStep,
          decreaseStep,
          setExpressCount,
          true
        );
        break;

      default:
        break;
    }
  };

  const _getRoomName = (room) => {
    return `(${room.apartmentName})`;
  };

  const stepSubTitle = (currentRoom, step) => {
    switch (step) {
      case 1:
        break;

      case 2:
        return _getGuestString(currentRoom.people);

      case 3:
        return _getRoomName(currentRoom);

      case 4:
        return (
          <span className="subtitle__small">
            * Наличие свободных номеров проверяет отдел
            <br />
            бронирования после получения заявки.'
          </span>
        );

      default:
        return "";
    }
  };

  const renderBtn = () => {
    return (
      <div className="buttons__wrapper">
        {backIsVisible && (
          <Button
            type="small"
            color="green"
            text="Назад"
            action={handlePrevStep}
          />
        )}
        {nextIsVisible && (
          <Button
            type="small"
            color="green"
            text="Далее"
            action={handleNextStep}
            isBtnDisabled={isBtnDisabled}
          />
        )}
      </div>
    );
  };
  return (
    <div className="left__header">
      <div className="flex flex-col">
        <span>Шаг {step}.</span>
        <span>{getTitle(step, currentRoom.id + 1)}</span>
        <span>{stepSubTitle(currentRoom, step)}</span>
      </div>

      {renderBtn()}
    </div>
  );
};

export default LeftHeader;
